export default class Street {
	id: number;		//ид
	name: string;	//название улицы
}